import {storage} from '@/plugins/firebase'

export default {
    getUserMedia (userId, mediaId, eltId) {
        const ref = storage.ref('users/' + userId + '/' +mediaId);
        return ref.getDownloadURL()
            .then((imageUrl) => {
                if (eltId) {
                    const elt = document.getElementById(eltId);
                    if (elt.tagName === 'IMG')
                        elt.setAttribute('src', imageUrl);
                    else
                        elt.style.backgroundImage = "url(" + imageUrl + ")"
                }
                else
                    return imageUrl;
            })
            .catch((error) => {
                window.console.error(error);
            });
    },

    getVideoLikeMedia (userId, mediaId, eltId) {
        const ref = storage.ref('videolikes/' + userId + '/' +mediaId);
        return ref.getDownloadURL()
            .then((imageUrl) => {
                if (eltId) {
                    const elt = document.getElementById(eltId);
                    if (elt.tagName === 'IMG')
                        elt.setAttribute('src', imageUrl);
                    else
                        elt.style.backgroundImage = "url(" + imageUrl + ")"
                }
                else
                    return imageUrl;
            })
            .catch((error) => {
                window.console.error(error);
            });
    },

    getVideoLikeMediaUrl (userId, mediaId) {
        const ref = storage.ref('videolikes/' + userId + '/' + mediaId);
        return ref.getDownloadURL();
    },

    getMessageMediaUrl (chatRoomId, mediaId) {
        const ref = storage.ref('messages/' + chatRoomId + '/' + mediaId);
        return ref.getDownloadURL();
    },

    getUserMediaUrl (userId, mediaId) {
        const ref = storage.ref('users/' + userId + '/' + mediaId);
        return ref.getDownloadURL();
    },

    getUserMediaDeletedUrl (userId, mediaId) {
        const ref = storage.ref('deleted/' + userId + '/' + mediaId);
        return ref.getDownloadURL();
    },

    getTicketMediaURL (ticketId, attachmentId) {
        const ref = storage.ref('tickets/' + ticketId + '/' +attachmentId);
        return ref.getDownloadURL();
    },

    getReportMediaURL (reportId, attachmentId) {
        const ref = storage.ref('reports/' + reportId + '/' +attachmentId);
        return ref.getDownloadURL();
    },

    uploadMediaFromDataURL (userId, mediaId, dataURL) {
        const ref = storage.ref('users/' + userId + '/' + mediaId);
        const metadata = {
            contentType: 'image/jpeg',
        };
        window.console.log("uploadMediaFromDataURL");
        return ref.putString(dataURL, 'data_url', metadata);
    },

    deleteUserMedia (userId, mediaId) {
        const ref = storage.ref('users/' + userId + '/' + mediaId);
        return ref.delete();
    },
}
